import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CancelShippingOrderForm";
import {cancelHoldShipment} from "../../actions/ShippingApiActions";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {Map} from "immutable";

function validateForm(values, props) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class HoldShipmentFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      reason: values.get("reason")
    }
    return this.props.holdShipment(updatedValues)
      .then((response) => {
        if (response.data.holdShipment.errors.length <= 0) {
          this.props.cancelHoldShipment();
        } else {
          let errors = createValidationErrors(response.data.holdShipment.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelHoldShipment();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Holding the shipment will prevent the shipment from starting until the hold is released."
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const HOLD_SHIPMENT = gql`
  mutation holdShipment($data: CancelShippingOrderInput!) {
    holdShipment(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(HOLD_SHIPMENT, {
    props: ({ mutate }) => ({
      holdShipment: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelHoldShipment})(withMutation(HoldShipmentFormContainer));